/**
 * Application configuration
 * Centralizes environment variable handling and provides type-safe config access
 */

export const config = {
  /**
   * Cloudflare Workers API configuration
   */
  cloudflare: {
    // In dev, use relative URL (goes through Vite proxy)
    // In prod, VITE_CF_API_URL must be set via .env.[environment]
    url: (import.meta.env.VITE_CF_API_URL ||
      (import.meta.env.DEV ? "" : "http://localhost:8787")) as string,
  },

  isProduction: () => config.cloudflare.url.includes("production"),

  getOldAppUrl: () =>
    config.isProduction()
      ? "https://mobile.backflip.com/"
      : "https://staging-mobile.backflip.com/",

  /**
   * Application environment
   */
  env: {
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    mode: import.meta.env.MODE,

    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN,
    hubspotPortalId: import.meta.env.VITE_HUBSPOT_PORTAL_ID as
      | string
      | undefined,
  },
} as const

/**
 * Get the Zion GraphQL endpoint URL
 */
export const getZionUrl = () => {
  return new URL("/proxy", getCloudflareUrl()).toString()
}

/**
 * Get the Cloudflare API endpoint URL
 */
export const getCloudflareUrl = () => config.cloudflare.url

/**
 * Type-safe environment variable getter
 */
export const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key]
  if (!value && !defaultValue) {
    throw new Error(`Environment variable ${key} is required but not set`)
  }
  return value || defaultValue!
}
